// extracted by mini-css-extract-plugin
export default {"body":"animal-list_body__D6hiS","strong":"animal-list_strong__ZdXZT","normal":"animal-list_normal__DV69i"};